var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import axios from 'axios';
import queryString from 'query-string';
import { getAccessToken } from '@smile-next/api';
import { REQUEST_TIMEOUT } from "../../../constants/request-timeout";
import { getEnv } from "../../../helpers/env-helper";
import { DrillType, Subject } from "../constants/drill";
var DrillApi = /** @class */ (function () {
    function DrillApi() {
        this.axiosInstance = axios.create();
    }
    // 現在教科書出版社設定されている全てのコース一覧を取得する
    DrillApi.prototype.getCourseList = function (value) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, env, requestModified, parameters, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getAccessToken({ withBearer: true })];
                    case 1:
                        accessToken = _b.sent();
                        env = getEnv();
                        requestModified = {
                            baseURL: env.api.drill,
                            headers: {
                                Authorization: accessToken,
                            },
                            timeout: REQUEST_TIMEOUT,
                        };
                        parameters = value == null ? '' : "?" + queryString.stringify(value, { encode: true, skipNull: true });
                        return [4 /*yield*/, ((_a = this.axiosInstance) === null || _a === void 0 ? void 0 : _a.request(__assign({ url: "rest/drillweb/course" + parameters }, requestModified)))];
                    case 2:
                        response = _b.sent();
                        if (!response || !response.data || !response.data.course) {
                            throw new Error('DrillApi.getCourseList: コースの取得に失敗しました。');
                        }
                        return [2 /*return*/, response.data.course];
                }
            });
        });
    };
    /**
     * かな問題を含むコース一覧を取得する
     *
     * かな問題はgetCourseList()を引数なしで呼び出すだけでは取得できないので、
     * 別途明示的に取得する。
     * サーバー側の実装の問題と思われるが、デグレリスクが怖いとのことなので
     * フロントエンド側で対処する。
     */
    DrillApi.prototype.getCourseListWithKana = function () {
        return __awaiter(this, void 0, void 0, function () {
            var kanaProps, courseList, kanaCourse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        kanaProps = { grade: 1, subject: Subject.KOKUGO, drillType: DrillType.KANA };
                        return [4 /*yield*/, this.getCourseList()];
                    case 1:
                        courseList = _a.sent();
                        kanaCourse = [];
                        if (!(courseList.find(function (_a) {
                            var grade = _a.grade, subject = _a.subject, drillType = _a.drillType;
                            return grade === kanaProps.grade && subject === kanaProps.subject && drillType === kanaProps.drillType;
                        }) == null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getCourseList(__assign(__assign({}, kanaProps), { includeUnit: false, includeSubunit: false, includeDrill: false, includeUrl: false }))];
                    case 2:
                        kanaCourse = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, __spreadArrays(courseList, kanaCourse)];
                }
            });
        });
    };
    return DrillApi;
}());
export { DrillApi };
export var drillApi = new DrillApi();
